











import { Vue, Prop, Component } from 'vue-property-decorator';
import Heading1 from '@/components/Atoms/Heading/Heading1.vue';

@Component({
  components: {
    Heading1,
  },
})
export default class LeadSentence extends Vue {}
